let rightMatModulePromise = null;
let rightEmrModulePromise = null;

export const loadRightMatApplication = () => {
  if (!rightMatModulePromise) {
    rightMatModulePromise = import('../components/Methadone').catch(error => {
      rightMatModulePromise = null;
      throw error;
    });
  }
  return rightMatModulePromise;
};

export const loadRightEmrApplication = () => {
  if (!rightEmrModulePromise) {
    rightEmrModulePromise = import('../components/RightEMRWorkspace').catch(error => {
      rightEmrModulePromise = null;
      throw error;
    });
  }
  return rightEmrModulePromise;
};

export const preloadApplication = applicationKey => {
  if (applicationKey === 'methadone') return loadRightMatApplication();
  if (applicationKey === 'rightemr') return loadRightEmrApplication();
  return Promise.resolve(null);
};

export const canBackgroundPreload = () => {
  const connection = typeof navigator === 'undefined' ? null : navigator.connection;
  if (connection?.saveData) return false;
  return !/^(slow-2g|2g)$/i.test(connection?.effectiveType || '');
};
